import React, { useState } from "react"
import styled from "styled-components"
import MenuItems from "./MenuItems"
import { Link, useStaticQuery, graphql } from "gatsby"
// import excerptHtml from "excerpt-html"
import Parser from "html-react-parser"

import { Typography } from "@material-ui/core"

import Dropdown from "./Dropdown"

import * as theme from "../../theme"

const MainMenu = ({ path, className }) => {
  const [selectedMenu, setSelectedMenu] = useState(null)

  const { emergency_number, emergency_headline } = useMenuQuery()

  return (
    <Menu className={className}>
      <Desktop>
        <MenuItems slug="main-menu">
          {items => {
            return items.map(item => (
              <ItemContainer
                key={item.id}
                onMouseEnter={() => setSelectedMenu(item.id)}
                onMouseLeave={() => setSelectedMenu(null)}
              >
                {!!item.children ? (
                  <Dropdown
                    id={item.id}
                    items={item.children}
                    selectedMenu={selectedMenu}
                    path={path}
                  >
                    <Typography variant="subtitle2" noWrap>
                      {Parser(item.title)}
                    </Typography>
                  </Dropdown>
                ) : (
                  <NavItem>
                    <Typography variant="subtitle2" noWrap>
                      <Link
                        to={item.pathname}
                        className={
                          item.active || item.activeParent ? "active" : ""
                        }
                      >
                        {Parser(item.title)}
                      </Link>
                    </Typography>
                  </NavItem>
                )}
              </ItemContainer>
            ))
          }}
        </MenuItems>
      </Desktop>

      <EmergencyContact>
        {!!emergency_headline && (
          <EmergHeadline variant="caption" color="inherit">
            {emergency_headline}
          </EmergHeadline>
        )}
        <a href={"tel:" + emergency_number}>
          <Typography variant="body1" color="inherit">
            {emergency_number}
          </Typography>
        </a>
      </EmergencyContact>
    </Menu>
  )
}

export default MainMenu

const Desktop = styled.div`
  @media (max-width: 799px) {
    display: none;
  }
  display: flex;
  align-items: flex-end;
`
const Menu = styled.nav`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  a {
    text-decoration: none;
  }
`

const ItemContainer = styled.div``

const NavItem = styled.div`
  color: inherit;
  padding: 15px 25px;
  a {
    color: inherit;
  }
`

const EmergencyContact = styled.div`
  @media (min-width: 800px) {
    border-left: 1px solid #1e65a9;
    padding-left: 20px;
    padding-right: 1.5vw;
    margin-left: 20px;
  }
  color: ${theme.color.dark};
  a {
    color: inherit;
  }
  padding-right: 20px;
  margin-bottom: 10px;
  text-transform: uppercase;
`

const EmergHeadline = styled(Typography)`
  color: ${theme.color.dark};
`
const useMenuQuery = () => {
  const { wordsbyData } = useStaticQuery(
    graphql`
      {
        wordsbyData {
          emergency_headline
          emergency_number
        }
      }
    `
  )
  const data = { ...wordsbyData }
  return data
}
